/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _join = _interopRequireDefault(require("../../../common/join"));
function prepareClassName() {
  var states = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var classNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var disabled = states.disabled,
    icon = states.icon,
    active = states.active,
    pressed = states.pressed,
    over = states.over,
    children = states.children,
    focused = states.focused,
    iconFirst = states.iconFirst,
    rtl = states.rtl,
    ellipsis = states.ellipsis,
    align = states.align,
    verticalAlign = states.verticalAlign,
    wrap = states.wrap,
    overflow = states.overflow,
    iconPosition = states.iconPosition;
  var className = classNames.className,
    rootClassName = classNames.rootClassName,
    disabledClassName = classNames.disabledClassName,
    activeClassName = classNames.activeClassName,
    pressedClassName = classNames.pressedClassName,
    overClassName = classNames.overClassName,
    focusedClassName = classNames.focusedClassName,
    theme = classNames.theme;
  var preparedClassname = (0, _join.default)(className, rootClassName, theme && "".concat(rootClassName, "--theme-").concat(theme), disabled && disabledClassName, disabled && "".concat(rootClassName, "--disabled"), active && activeClassName, active && "".concat(rootClassName, "--active"), pressed && pressedClassName, pressed && "".concat(rootClassName, "--pressed"), over && overClassName, over && "".concat(rootClassName, "--over"), focused && focusedClassName, focused && "".concat(rootClassName, "--focused"), rtl ? "".concat(rootClassName, "--rtl") : "".concat(rootClassName, "--ltr"), ellipsis && "".concat(rootClassName, "--ellipsis"), align && "".concat(rootClassName, "--align-").concat(align), !children && "".concat(rootClassName, "--no-children"), verticalAlign && "".concat(rootClassName, "--vertical-align-").concat(verticalAlign), overflow === true && "".concat(rootClassName, "--overflow-visible"), overflow === false && "".concat(rootClassName, "--overflow-hidden"), wrap === true && "".concat(rootClassName, "--wrap"), wrap === false && "".concat(rootClassName, "--nowrap"), icon && "".concat(rootClassName, "--has-icon"), iconPosition && "".concat(rootClassName, "--icon-position-").concat(iconPosition), iconFirst ? "".concat(rootClassName, "--icon-first") : "".concat(rootClassName, "--icon-last"));
  return preparedClassname;
}
var _default = prepareClassName;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Button/src/prepareClassName.js
// module id = 645
// module chunks = 0